import React from 'react'

import AndroidHandler from 'utils/androidHandler'
import { SHARE_TEXT } from 'app/ProfileRevampPage/constants'
import { useProfile } from 'app/ProfileRevampPage/hooks/useProfile'

export const useShare = () => {
  const androidHandler = AndroidHandler()
  const { profileId } = useProfile()

  const [socialShareDrawerOpen, setSocialShareDrawerOpen] =
    React.useState<boolean>(false)

  const shareUrl = `${process.env.NEXT_PUBLIC_BASE_URL}/profil/${profileId}`

  const onClickShare = () => {
    if (androidHandler.enabled) {
      androidHandler.shareToolkitUrl(`${SHARE_TEXT} ${shareUrl}`)
    } else {
      setSocialShareDrawerOpen(true)
    }
  }

  return {
    shareUrl,

    // Social Drawer states
    socialShareDrawerOpen,
    setSocialShareDrawerOpen,

    // Actions
    onClickShare,
  }
}
